import React from 'react';
import { Col, Container, Row } from '@gjensidige/core-grid';
import { Text, Title } from '@gjensidige/core-typography';
import { useCmsContext } from '@gjensidige/service-cms';

import friends from '../../resources/images/friends.svg';
import { LayoutContent } from '../Layout';
import TextContainer from '../TextContainer';
import Answers from './Answers';
import AskAdvisor from './AskAdvisor';
import styles from './Summary.module.scss';
import WayForward from './WayForward';

const Summary = () => {
  const { getText } = useCmsContext();

  return (
    <>
      <Container>
        <LayoutContent clickable />
        <Row>
          <Col xs={12} md={6} className={styles.col}>
            <TextContainer className={styles.topContent}>
              <Title tag="h1" size="h2">
                {getText('housing.check.summary.title')}
              </Title>
              <img className={styles.image} src={friends} alt="jumping-man" />
            </TextContainer>
            <Text size="lead" className={styles.info}>
              {getText('housing.check.summary.text')}
            </Text>
            <Answers />
          </Col>
        </Row>
      </Container>
      <WayForward />
      <AskAdvisor />
    </>
  );
};

export default Summary;
